export const conditionalSpread = (spread: any, condition: boolean) => {
  if (condition) {
    return spread;
  }
  return Array.isArray(spread) ? [] : {};
};

export const getRandomItem = (arr: any[]) => {
  const randomIndex = Math.floor(Math.random() * arr.length);
  return arr[randomIndex];
};
